module.exports = __webpack_public_path__ + "static/img/mood3.b847f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood3.png
// module id = 7oZu
// module chunks = 1